import React, { useState, useEffect, useRef, useContext } from 'react'
// import Buttons from '../../components/buttons/buttons'
import { RhyBusButton  as Buttons} from '@rhybus/button'
import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusInputText } from '@rhybus/form-controls'
import { RhyBusNoresult as Noresult } from '@rhybus/noresult'
// import { COLUMN_NAMES, ListNames } from '../../configuration'
// import PageOverlay from '../../pageoverLay/pageoverLay'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'
import { rhybusRListsHttp } from '../../components/api/rhybus-list-http'
import { COLUMN_NAMES, ListNames } from '../../config/configuration'
import { UserContext, UserInitalValue } from '../../store/UserContextProvider'
import { DocumentIconNames } from '@rhybus/common-functions'
export default function Policymemosguidelines(props?: any) {
  const { me }: typeof UserInitalValue = useContext(UserContext)

  const pageMainref = useRef<any>(null)
  const [policyMemoItems, setPolicyMemoItems] = useState<any>([])
  const [policyMemoFolders, setPolicyMemoFolders] = useState<any[]>([{ files: [], folder: {} }])
  const [policyMemoFiles, setPolicyMemoFiles] = useState<any>({
    generalKey: '',
    files: []
  })

  const [accordionsArray, setAccordionsArray] = useState<any[]>([])
  const [filesArray, setFilesArray] = useState<any>([])
  const [loading, setLoading] = useState(true)
  const [searchQuery, setSearchQuery] = useState<string>('')
  const { userProfileIsLoading } = useContext(UserContext)

  useEffect(() => {
    if (searchQuery?.trim() === '') {
      dataArray(policyMemoItems)
    } else {
      filterItems(searchQuery, policyMemoItems)
    }
  }, [policyMemoItems, searchQuery])
  useEffect(() => {
    if (pageMainref?.current) {
      pageMainref?.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    if (!userProfileIsLoading) {
      fetchData()
    }
  }, [userProfileIsLoading])
  useEffect(() => {
    dataArray(policyMemoItems)
  }, [policyMemoFiles, policyMemoFolders])
  const getFiles = async () => {
    const list = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
    const listBlobs: any = await list.blobs().listAll()
    return listBlobs
  }
  const getFilesForFolder = (eKey: string, filesToFilter?: any[]) => {
    const requiredBlobs = filesToFilter?.filter((blob) => blob?.itemKey === `${ListNames.POLICY_MEMO}__${eKey}`)
    const filteredFiles = requiredBlobs?.[0]?.blobs?.filter((item: { fileName: string | string[] }) => !item?.fileName?.includes('IsDeleted'))
    return filteredFiles
  }
  const GENERAL = 'general'


  const getFolders = async () => {
    const folders = await getPolicyMemoFolders()
    const files = await getFiles()
    const generalFolder = folders.filter(item => item.Path === GENERAL);
    if (generalFolder.length === 0) {
      console.error("No folder found with the title 'GENERAL' or it is marked as deleted.")
    }
    const generalFiles = getFilesForFolder(generalFolder?.[0]?.eKey, files)
    setPolicyMemoFiles({
      itemKey: generalFolder?.[0]?.eKey ?? '',
      files: generalFiles ?? [],
    })
    const foldersWithFiles = folders.filter(item => item.Path !== GENERAL)
      .map((folder: any) => ({
        folder: folder,
        files: getFilesForFolder(folder.eKey, files)
      }))
    setPolicyMemoFolders(foldersWithFiles)
  }

  const fetchData = async () => {
    const data = await getPolicyMemoFolders()
    await getFolders()
    setPolicyMemoItems(data)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }
  const getPolicyMemoFolders = async () => {
    const list = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
    const listItems = await list
      .query()
      .filter(`${COLUMN_NAMES.IsDeleted} eq false`)
      .select(
        COLUMN_NAMES.Path,
        COLUMN_NAMES.eKey,
        COLUMN_NAMES.eTag,
        COLUMN_NAMES.ItemModified,
        COLUMN_NAMES.ItemModifiedBy,
        COLUMN_NAMES.ItemCreatedBy,
        COLUMN_NAMES.ItemCreated
      )
      .expand(
        COLUMN_NAMES.ItemModifiedBy,
        COLUMN_NAMES.ItemCreatedBy
      )
      .orderBy([{ ascending: true, orderBy: COLUMN_NAMES.Path }])
      .get()
    return listItems as any[]
  }
  function dataArray(policyMemoItems: any) {
    let accordionitems: any[] = []
    let filesitems: any[] = []

    policyMemoItems?.map((policymemoList: any) => {
      let filesForThisItem: any[] = []
      if (policymemoList?.eKey) {
        // Log eKey for debugging
        const { files, itemKey } = policyMemoFiles
        if (itemKey === policymemoList?.eKey) {
          files.forEach((item: any) => {
            filesForThisItem.push({ ...item, eKey: policymemoList.eKey })
          })
        }
        policyMemoFolders?.filter((item: any) => {
          if (item.folder.eKey === policymemoList?.eKey) {
            item?.files !== undefined && item?.files?.forEach((items: any) => {
              filesForThisItem.push({ ...items, eKey: policymemoList.eKey })
            })
          }
        })
      }
      // Assign the filtered files to policymemoList.Files
      policymemoList.Files = filesForThisItem;
      // Add to accordion items if it's not 'Forms' or 'GENERAL'
      if (policymemoList?.Path !== 'Forms' && policymemoList?.Path !== GENERAL) {
        accordionitems.push({
          title: policymemoList?.Path,
          Files: policymemoList?.Files,  // Pushed files into the item
          count: policymemoList?.Files?.length < 10
            ? '0' + policymemoList?.Files?.length
            : policymemoList?.Files?.length,
          content: (
            <ul className="list-type-none px-2 d-flex row">
              {fileItems(policymemoList?.Files)}
            </ul>
          ),
        })
      } else {
        if (policymemoList?.Path !== 'Forms') {
          filesitems.push(policymemoList)
        }
      }
    })
    // Sort `filesitems` and `accordionitems` as needed
    filesitems?.sort((a: any, b: any) => a?.Path?.localeCompare(b?.Path))
    setFilesArray(filesitems)

    accordionitems?.forEach((item: any) => {
      if (item && Array.isArray(item.Files)) {
        const filesList = [...item.Files]
        filesList.sort((a: any, b: any) => a?.Path?.localeCompare(b?.Path))
        item.Files = filesList
      }
    })
    accordionitems?.sort((a: any, b: any) => a?.path?.localeCompare(b?.path))
    setAccordionsArray(accordionitems)
  }
  useEffect(() => {
    const policyMemoItems = [policyMemoFiles?.files.length > 0 ? `${policyMemoFiles?.generalKey}` : '', ...policyMemoFolders]
    props?.sendPmgItemsToParent?.(policyMemoItems)
  }, [policyMemoFiles, policyMemoFolders])

  const display = filesArray
    .filter((file: any) => file?.Files?.length > 0) // Filter first
    .map((file: any) => file.Files)

  const FileTypes: Record<string, string> = {
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    gif: 'image/gif',
    jpe: 'image/jpeg',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    msg: '',
    pdf: 'application/pdf',
    png: 'image/png',
    pps: 'application/vnd.ms-powerpoint',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    txt: 'text/plain',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }

  const onFileClick = async (file: any) => {
    const fileReturnType = (productMap: any) => {
      for (const [key, value] of productMap) {
        if (key === 'type') return value
      }
      return ''
    }
    const getFileType = (fileName: string) => {
      const extension = fileName?.split('.').pop()?.toLowerCase()
      return extension && FileTypes[extension] ? FileTypes[extension] : 'application/octet-stream'
    }
    try {
      const eKey = file?.eKey ?? ''
      const list = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
      await list
        .blobs()
        .getContent(eKey, file?.fileName, file?.folderName)
        .then((data) => {
          const metadataMap =
            file?.metadata instanceof Map
              ? file?.metadata
              : new Map(Object.entries(file?.metadata || {}))
          let filetype = fileReturnType(metadataMap)
          if (filetype === undefined || filetype === '') {
            filetype = getFileType(file?.fileName)
          }
          const blob = new Blob([data], { type: filetype })
          const blobUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = blobUrl
          link.download = file?.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100)
        })
    } catch (error) {
      console.error('Download failed:', error)
    }
  }

  const fileItems = (files: any) => {
    return (
      <>
        {files && files?.length > 0 ? <ul className='list-type-none px-2 d-flex row'>
          {files?.map((file: any) =>
            <li className='list-type-arrow col-lg-3 col-sm-4' key={file?.fileName}>
              <div className="links d-flex align-items-center breakall">
                <span className={`me-1 ${DocumentIconNames(file?.fileName)}`}></span>
                <a
                  tabIndex={0}
                  aria-label={file.fileName}
                  className="links fw-semibold font-13 links-over-underline links"
                  title={file?.fileName}
                  href="#"
                  onKeyDown={(e: any) => { if (e.key === 'Enter') { e.preventDefault(); onFileClick(file) } }}
                  onClick={(e: any) => { e.preventDefault(); onFileClick(file) }}

                >
                  {file.fileName}
                </a>
              </div>
            </li>
          )}
        </ul> : <div className='min-h-100 d-flex align-items-center justify-content-around'>
          <Noresult />
        </div>
        }
      </>
    )
  }
  const inputValue = (e: any) => {
    if (e?.target?.value) {
      setSearchQuery(e.target.value)
    } else {
      setSearchQuery('')
    }
  }
  const clearSearchQuery = (e: any) => {
    setSearchQuery('')
  }
  const filterItems = (searchQueryVal: string, policyMemoItems: any) => {
    const queryLowerCase = searchQueryVal?.toLowerCase();
    const filteredData = policyMemoItems?.map((policymemoList: any) => {
      if (policymemoList?.Files && policymemoList?.Path !== 'Forms') {
        const policyMemoFiles = policymemoList?.Files?.results ?? policymemoList?.Files;
        const filtered = policyMemoFiles?.filter((policyMemo: any) => {
          const name = policyMemo?.fileName || ''; // ✅ Corrected from policyMemoItems?.Name
          return name?.toLowerCase()?.includes(queryLowerCase);
        });

        // If any files matched, return this folder item with the filtered files
        if (filtered.length > 0) {
          return { ...policymemoList, Files: filtered };
        }

      } else if (policymemoList?.Path !== 'Forms') {
        const name = policymemoList?.Path || ''; // ✅ Match folder name
        const isMatched = name?.toLowerCase()?.includes(queryLowerCase);
        if (isMatched) {
          return policymemoList;
        }
      }
      return null;
    })?.filter(Boolean);

    dataArray(filteredData);
  };

  return (
    <>
      <RhyBusPageHeader
        pageTitle={'Policy Memos & Guidelines'}
        pageHeaderIcon="icon-rb-pmg"
        headerRightContent={<>
          {policyMemoItems?.length > 0 &&
            <div className="d-flex align-items-center justify-content-end gap-2">
              <label htmlFor="announcements-search" className="sr-only">Search announcements</label>
              <RhyBusInputText
                type='search'
                iconRight={true}
                wrapperClassName='min-w-250'
                customIcon="icon-rb-search"
                placeholder="Search Policy Memos & Guidelines"
                value={searchQuery}
                onChange={(e: any) => inputValue(e)}
                onClick={(e: any) => clearSearchQuery(e)}
              />
              <Buttons
                label="Clear All"
                className='btn-sm d-flex align-items-center links1 links-over-underline font-14'
                type="button"
                onClick={(e: any) => clearSearchQuery(e)}
                variant='ghost'
              />
            </div>}
        </>}
      />
      <div className="container mb-3">
        <div className="card shadow border-radius2 mt-3">
          <div className="card-body">
            <div className='row'>
              <div>
                {display && display?.length > 0 ? <div className='mx-3 my-0 h-100 '>
                  <div className="m-0 bgcolor-16 p-2">
                    <h2 className='fw-semibold font-14 text-color-11 m-0' aria-live='polite' tabIndex={0}>{'General'} ({display[0]?.length < 10 ? ('0' + display[0]?.length) : display[0]?.length})</h2>
                  </div>
                  <div>
                    {fileItems(display[0])}
                  </div>
                </div>
                  : ''}
              </div>
              {accordionsArray?.map((folderItems: any) =>
                <div className="" key={folderItems.path}>
                  <div className='mx-3 my-0 h-100 '>
                    <div className="m-0 bgcolor-16 p-2">
                      <h2 className='fw-semibold font-14 text-color-11 m-0' tabIndex={0} aria-label={`${folderItems.title} ${folderItems.count}`}>{folderItems.title} ({folderItems.count})</h2>
                    </div>
                    <div>
                      {folderItems.content}
                    </div>
                  </div>
                </div>
              )}
              {
                accordionsArray.length === 0 && filesArray.length === 0 && <div className='min-h-200 d-flex align-items-center justify-content-around'>
                  <Noresult />
                </div>
              }
            </div>
          </div>
        </div>
        {loading && <PageOverlay />}
      </div>
    </>
  )
}
